var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('h3',[_c('router-link',{attrs:{"to":{
        name: `boardlist`,
        query: { data: JSON.stringify(_vm.item)}
      }}},[_vm._v(_vm._s(_vm.item.title))])],1),_c('div',{on:{"click":_vm.toggle}},[_vm._v("열기")]),(_vm.isFolder)?_c('ul',{style:({ display: this.isBlock })},_vm._l((_vm.children),function(child,index){return _c('tree-item',{key:index,attrs:{"item":child},on:{"make-folder":function($event){return _vm.$emit('make-folder', $event)},"add-item":function($event){return _vm.$emit('add-item', $event)}}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }